import tippy from 'tippy.js';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-hint')];

	const OPTIONS = {
		arrow: true,
		interactive: true,
		duration: 300,
		position: 'right-start',
	};

	const init = (element) => tippy(element, OPTIONS);


	elements.forEach(init);
};
